import { io } from "socket.io-client";
import React from 'react';
import { connect } from "react-redux";
import { getUnreadThread } from "../../actions/socket/getUnreadThread";
import { getThreads } from "../../actions/socket/getThreads";
import { setUserLogout } from '../../actions/logout';
import { getUnreadCount } from "../../actions/socket/getUnreadCount";
import { getAllThread } from "../../actions/socket/getAllThread";
import { socketUrl } from '../../config';

const secure = socketUrl && socketUrl.indexOf('https://') >= 0 ? true : false;

export const socket = io(socketUrl,
    {
        secure,
        upgrade: true,
        transports: ['websocket'],
        reconnection: true,
        forceNew: true,
        rejectUnauthorized: false
    }
);
class SocketProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null
        };
    }

    componentDidMount = () => {
        const { userId, getUnreadThread, getThreads, getUnreadCount, getAllThread, setUserLogout } = this.props;

        socket.on(`viewMessage-${userId}`, (data) => {
            getThreads({ threadType: 'renter', threadId: data?.data?.threadId });
            getAllThread();
            getThreads({ threadType: 'owner', threadId: data?.data?.threadId });
            getUnreadThread();
            getUnreadCount();
        })
        
        socket.on(`userLogout-${userId}`, () => {
            setUserLogout({ isAdmin: false });
            this.setState({ id: userId });
        });
    }

    componentDidUpdate = () => {
        const { userId, getUnreadThread, getUnreadCount } = this.props;

        socket.on(`viewMessage-${userId}`, (data) => {
            getThreads({ threadType: 'renter', threadId: data?.data?.threadId });
            getAllThread();
            getThreads({ threadType: 'owner', threadId: data?.data?.threadId });
            getUnreadThread();
            getUnreadCount();
        })
    }

    componentWillUnmount() {
        const { id } = this.state;
        if (id) {
            socket.off(`userLogout-${id}`);
            socket.off(`viewMessage-${id}`);
        }
    }

    render() {
        const { userId, adminId, setUserLogout } = this.props;

        socket.on(`userLogout-${userId}`, () => {
            setUserLogout({ isAdmin: false });
            this.setState({ id: userId });
        });

        return (
            <>
            </>)
    }
}

const mapState = (state) => ({
    userId: state?.account?.data?.userId,
    adminId: state?.account?.privileges?.id
});

const mapDispatch = {
    getUnreadThread,
    setUserLogout,
    getThreads,
    getUnreadCount,
    getAllThread
};

export default connect(mapState, mapDispatch)(SocketProvider);